<template>
  <div @click="click">
    <span class="dia-mes">{{parseDate(row[column.field])}}</span>
    <span class="nome-dia">{{parseDateName(row[column.field])}}</span>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DataItem',
  props: ['column', 'row'],
  methods: {
    parseDate (value) {
      if ((/\d{4}-\d{2}-\d{2}/).test(value)) {
        return moment(value, 'YYYY-MM-DD').format('DD/MM/YY')
      }
      return moment.unix(parseInt(value)).format('DD/MM/YY')
    },
    parseDateName (value) {
      const data = moment(value, 'YYYY-MM-DD HH:mm:ss')
      const diaSemana = data.locale('pt-br').format('dddd')
      return diaSemana.replace(diaSemana.charAt(), diaSemana.charAt().toUpperCase())
    },
    click () {
      if (this.column && this.column.click) {
        this.column.click(this.row)
      }
      this.$emit('click', this.row)
    }
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@200&family=Open+Sans:wght@300&display=swap');
</style>
